import React from "react";
import {
    BlockCollab,
    BlockTitleCollab,
    BadgeCollab,
    FieldGrid,
    Field,
    FieldInput,
    FieldSelectReal,
    Req,
    SInput,
    SPhoneInputStyle,
} from "../index";
import { Controller, useFormContext } from "react-hook-form";

export default function BlockUrgence() {
    const { control } = useFormContext();
    return (
        <BlockCollab>
            <BlockTitleCollab>
                Contact d'urgence{" "}
                <BadgeCollab>À compléter par vous</BadgeCollab>
            </BlockTitleCollab>

            <FieldGrid>
                <Field>
                    <label>
                        Nom et prénom <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    placeholder="Nom et prénom"
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                />
                            );
                        }}
                        name="emergency_contacts[0].full_name"
                    />
                </Field>
                <Field>
                    <label>
                        Relation <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    placeholder="Relation"
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                />
                            );
                        }}
                        name="emergency_contacts[0].relationship"
                    />
                </Field>
                <Field>
                    <label>Email</label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    placeholder="Adresse email"
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                />
                            );
                        }}
                        name="emergency_contacts[0].email"
                    />
                </Field>
                <Field>
                    <label>
                        Téléphone <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        render={({
                            field: { onChange, onBlur, value, name, ref },
                        }) => {
                            const formatValue = value.startsWith("+")
                                ? value
                                : "+" + value;
                            return (
                                <SPhoneInputStyle
                                    international
                                    countryCallingCodeEditable={false}
                                    defaultCountry={"CH"}
                                    value={formatValue}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    error={false}
                                />
                            );
                        }}
                        name="emergency_contacts[0].phone_number"
                    />
                </Field>
            </FieldGrid>
        </BlockCollab>
    );
}
